import { h$1 as h, Y as m, h as v, me as b, m as f, o as g } from "../chunks/register-Ba9sFUKZ.js";
import * as w from "react";
import { f as y } from "../chunks/query-assigned-elements-CMnZBBH0.js";
import { i as E } from "../chunks/query-assigned-nodes-CUxn2IMs.js";
import { X as L } from "../chunks/button-base-BIJ5ovE-.js";
import { r as p } from "../chunks/motion-BJnrAa7l.js";
import { v as T } from "../chunks/mixin-CP6jLr_x.js";
import { V as B } from "../chunks/motion-primitive-kIGz-vOk.js";
import { d as M } from "../chunks/opens-by-DP5hIiRc.js";
import { R as C } from "../chunks/popup-DC9pFtAI.js";
import { h as x, f as k, d as O } from "../chunks/lifecycle-decorators-C04d1yHY.js";
const u = {
  beaconTagName: "beacon-tooltip"
}, z = h`[beacon-tag-name=beacon-tooltip] :where(*){margin:0;padding:0}`, N = h`@media (prefers-reduced-motion: no-preference){:host([motion-state=enabled]){transition-duration:var(--beacon-reference-motion-duration-3);transition-property:opacity;transition-timing-function:var(--tooltip-transition-timing-function, var(--beacon-system-motion-easing-decelerate-standard-1))}:host([motion-state=enabled]:not([open])){opacity:0}:host([motion-state=enabled][open]){opacity:1}:host([motion-state=enabled][open][closing]){--tooltip-transition-timing-function: var(--beacon-system-motion-easing-accelerate-emphasize-1);opacity:0}}`;
var A = (e, t, n, s) => {
  for (var o = t, i = e.length - 1, r; i >= 0; i--)
    (r = e[i]) && (o = r(o) || o);
  return o;
};
function $(e) {
  let t = class extends e {
    static get TooltipMotionStyles() {
      return [N];
    }
  };
  return t = A([
    x("TestTooltipMotion")
  ], t), t;
}
const R = h`:host{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-300);filter:drop-shadow(0 0 var(--beacon-reference-space-1) var(--beacon-reference-palette-grayscale-shadow-1));max-inline-size:15ch;min-inline-size:40px;padding:var(--beacon-system-space-cell-contained);text-align:center}.arrow{--arrow-inline-size: 6px;--arrow-block-size: 12px;background-color:initial;block-size:12px;inline-size:12px}.arrow[data-side=bottom]{transform:rotate(90deg)}.arrow[data-side=left]{transform:rotate(180deg)}.arrow[data-side=top]{transform:rotate(-90deg)}.arrow .arrow-vector{background-color:initial;block-size:var(--arrow-block-size);fill:var(--beacon-system-color-background-1);inline-size:var(--arrow-inline-size);inset-inline-end:-1px;position:absolute}`;
var S = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, c = (e, t, n, s) => {
  for (var o = s > 1 ? void 0 : s ? _(t, n) : t, i = e.length - 1, r; i >= 0; i--)
    (r = e[i]) && (o = (s ? r(t, n, o) : r(o)) || o);
  return s && o && S(t, n, o), o;
}, l;
const a = (l = class extends T(b).with(
  C,
  M,
  B,
  $
) {
  constructor() {
    super(...arguments), this.beaconTagName = u.beaconTagName, this._hovered = !1, this.show = (e) => {
      this.attachTooltipListeners(), !this.prefersReducedMotion && this.motionState === p.ENABLED ? (this.closing = !1, this.showCallback(e)) : this.showCallback(e);
    }, this.hide = (e) => {
      this.removeTooltipListeners(), !this.prefersReducedMotion && this.motionState === p.ENABLED ? this.closing = !0 : this.hideCallback(e);
    }, this.mouseOverTooltipListener = () => {
      this._hovered = !0, this.waitUntilMouseHoversTooltip && clearTimeout(this.waitUntilMouseHoversTooltip);
    }, this.mouseOutTooltipListener = (e) => {
      this._hovered = !1, this.hide(e);
    }, this.opensByMouseOutListener = (e) => {
      this.waitUntilMouseHoversTooltip = setTimeout(() => {
        this._hovered || this.hide(e);
      }, 100);
    };
  }
  static get styles() {
    return [super.styles, this.popupStyles, R, this.TooltipMotionStyles];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, z];
  }
  get text() {
    let e = "";
    return this.slottedElements ? (e = l.getCleanTextContent(
      this.slottedElements
    ), e) : (this.slottedNodes && (e = l.getCleanTextContent(this.slottedNodes)), e);
  }
  /**
   * Grabs the cleaned `.textContent` from the element's slotted content.
   * This is used to prevent `<style>` element contents from being assigned to the aria-description attribute.
   * @param slottedContent
   * @returns
   */
  static getCleanTextContent(e) {
    return [...e].reduce((t, n) => {
      var s, o;
      const i = (o = (s = n == null ? void 0 : n.textContent) == null ? void 0 : s.trim()) != null ? o : "";
      return t + i;
    }, "");
  }
  _renderArrowHTML() {
    return m`<div class="arrow">
      <svg
        aria-hidden="true"
        width="6"
        height="12"
        viewBox="0 0 6 12"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-vector">
        <path d="M6 0L0 6L6 12V0Z" />
      </svg>
    </div>`;
  }
  runOpensBySetup() {
    this.opensByElements.forEach((e, t) => {
      t.addEventListener("mouseenter", this.show), t.addEventListener("mouseleave", this.opensByMouseOutListener), t.addEventListener("focus", this.show), t.addEventListener("blur", this.hide), t instanceof L ? t.updateComplete.then(() => {
        var n;
        (n = t.button) == null || n.setAttribute("aria-description", this.text);
      }) : t.setAttribute("aria-describedby", this.id);
    });
  }
  runOpensByClean() {
    this.opensByElements.forEach((e, t) => {
      t.removeEventListener("mouseenter", this.show), t.removeEventListener("mouseleave", this.hide), t.removeEventListener("focus", this.show), t.removeEventListener("blur", this.hide);
    });
  }
  attachTooltipListeners() {
    this.addEventListener("mouseenter", this.mouseOverTooltipListener), this.addEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  removeTooltipListeners() {
    this.removeEventListener("mouseenter", this.mouseOverTooltipListener), this.removeEventListener("mouseleave", this.mouseOutTooltipListener);
  }
  closingAnimationCallback() {
    this.hideCallback();
  }
  applyAriaRole() {
    this.setAttribute("role", "tooltip");
  }
  render() {
    return m`
      <div id="tooltip">
        <slot></slot>
        ${this._renderArrowHTML()}
      </div>
    `;
  }
}, l.tagName = u.beaconTagName, l);
c([
  y({ slot: "", selector: ":not(style)" })
], a.prototype, "slottedElements", 2);
c([
  E({ slot: "", flatten: !0 })
], a.prototype, "slottedNodes", 2);
c([
  v({ attribute: "hovered", type: Boolean })
], a.prototype, "_hovered", 2);
c([
  k
], a.prototype, "removeTooltipListeners", 1);
c([
  O
], a.prototype, "applyAriaRole", 1);
let d = a;
const K = (e) => (f(e, d), g({
  tagName: e ? e + "-" + d.tagName : d.tagName,
  elementClass: d,
  react: w,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  K as default,
  K as reactBeaconTooltip
};
